import {createAsyncThunk} from "@reduxjs/toolkit"
import {AppThunkProps} from "store"
import {api} from "utils/http"
import {BasicMenu} from "types/BasicMenu"

type ReturnedType = {
    status: "success"
    menuList: BasicMenu[]
}

/**
 * Получения списка меню
 */
export const fetchBasicMenuList = createAsyncThunk<ReturnedType, undefined, AppThunkProps>(
    "basic-menu/list/fetch",
    async (_, {signal}) => {
        return api.get<ReturnedType>("/user/basic-menu/list", {signal})
    },
    {
        condition(_, {getState}) {
            const {basicMenu} = getState()
            return !basicMenu.ids.length
        }
    }
)
